import { useState } from "react";
import { ReceivingInvoiceIndexViewModel } from "../../../viewmodels/receiving/invoices/ReceivingInvoiceIndexViewModel";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { withRouter } from "../../../shared/utility";

import SlideOver from "../../../components/slideOver/SlideOver";

import InvoiceRecordDetails from "./records/InvoiceRecordDetails";
import InvoiceRecordProductDetails from "./records/InvoiceRecordProductDetails";
import InvoiceRecordAssemblyOptions from "./records/InvoiceRecordAssemblyOptions";
import InvoiceRecordInventory from "./records/InvoiceRecordInventory";
import InvoiceRecordsSearch from "./records/InvoiceRecordsSearch";
import ReceivingBarcodeLabel from "../../../components/forms/receiving/invoices/ReceivingBarcodeLabel";

function ReceivingInvoiceIndex(props) {
  const { addSnackbar, logout } = props;
  const {
    barcodeDetails,
    fetchInvoiceDetails,
    getReceivingInvoiceIndex,
    loading,
    receivingIndex,
    setSlideOver,
    slideOver,
    onGenerateBarcodePdf,
  } = ReceivingInvoiceIndexViewModel(logout, addSnackbar);

  const [invoiceDetails, setInvoiceDetails] = useState({
    supplier_name: "",
    product_condition: {
      label: "",
    },
    truck_condition: { label: "" },
    pallet_condition: { label: "" },
  });

  const fetchInvoiceDetailsClicked = async function (itemId) {
    const fetchedInvoice = await fetchInvoiceDetails(itemId);
    setInvoiceDetails(fetchedInvoice);
  };

  return (
    <div className="min-h-screen bg-[#F6F8FB] px-4 py-5 sm:px-6 lg:px-8">
      <div className="hide-for-print mx-auto max-w-7xl space-y-5">
        <section className="rounded-[18px] border border-[#E2E8F0] bg-white px-5 py-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)] sm:px-6">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#64748B]">
            QA Trace / Receiving
          </p>
          <h1 className="mt-1 text-[1.65rem] font-semibold tracking-tight text-[#0F172A] sm:text-3xl">
            Receiving Index
          </h1>
          <p className="mt-2 max-w-2xl text-sm leading-6 text-[#64748B]">
            Search received materials and review product, lot, inventory, and
            quality details from one traceability workspace.
          </p>
        </section>

        <div className="grid grid-cols-1 gap-5 xl:grid-cols-5">
          <div className="space-y-5 xl:col-span-3">
            <InvoiceRecordsSearch
              getReceivingInvoiceIndex={getReceivingInvoiceIndex}
            />
            <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
              <InvoiceRecordProductDetails invoiceDetails={invoiceDetails} />
              <div className="space-y-5">
                <InvoiceRecordDetails invoiceDetails={invoiceDetails} />
                <InvoiceRecordInventory
                  barcodeDetails={barcodeDetails}
                  invoiceDetails={invoiceDetails}
                  onGenerateBarcodePdf={onGenerateBarcodePdf}
                />
              </div>
            </div>
          </div>
          <div className="xl:col-span-2">
            <InvoiceRecordAssemblyOptions
              fetchInvoiceDetailsClicked={fetchInvoiceDetailsClicked}
              loading={loading}
              receivingIndex={receivingIndex}
            />
          </div>
        </div>
      </div>
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
      <ReceivingBarcodeLabel barcodeDetails={barcodeDetails} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReceivingInvoiceIndex),
);
